import { RootState } from '@/store/root-state';
import { createSelector } from '@reduxjs/toolkit';

const selectScheduledEmailsState = (state: RootState) => state.scheduledEmails;

export const selectScheduledEmails = createSelector(selectScheduledEmailsState, (s) => s.emails);
export const selectLoadingScheduledEmails = createSelector(selectScheduledEmailsState, (s) => s.loadingEmails);
export const selectErrorLoadingScheduledEmails = createSelector(
  selectScheduledEmailsState,
  (s) => s.errorLoadingEmails
);
export const selectActiveEmail = createSelector(selectScheduledEmailsState, (s) => s.activeEmail);
export const selectLoadingActiveEmail = createSelector(selectScheduledEmailsState, (s) => s.loadingActiveEmail);
export const selectErrorLoadingActiveEmail = createSelector(
  selectScheduledEmailsState,
  (s) => s.errorLoadingActiveEmail
);
export const selectUpdatingEmail = createSelector(selectScheduledEmailsState, (s) => s.updatingEmail);
export const selectErrorUpdatingEmail = createSelector(selectScheduledEmailsState, (s) => s.errorUpdatingEmail);
export const selectDeletingEmailUuid = createSelector(selectScheduledEmailsState, (s) => s.deletingEmailUuid);
export const selectErrorDeletingEmail = createSelector(selectScheduledEmailsState, (s) => s.errorDeletingEmail);

export const selectScheduledEmailByUuid = (uuid: string | undefined) =>
  createSelector(selectScheduledEmails, (emails) => emails?.find((e) => e.uuid === uuid));
